/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unstable-nested-components */
import React, { Component } from 'react';
import {
  Modal,
  Tab,
  Menu,
  Label,
  Breadcrumb,
  Icon,
  Popup,
  List as SemanticList,
  Header,
  Container,
  Input,
  Dropdown,
  Checkbox,
  Loader
} from 'semantic-ui-react';
import {
  Column, Table, List, AutoSizer, CellMeasurer, CellMeasurerCache
} from 'react-virtualized';
import FileSaver from 'file-saver';
import cx from 'classnames';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import Update from 'immutability-helper';
import 'react-virtualized/styles.css';
import api from '../../api';
import {
  HTML_UNIQUE,
  HTML_OTHER,
  HTML_UNMATCHED,
  HTML_IGNORE,
  HTML_VARIABLE,
  HTML_FUNCTION_UNIQUE,
  HTML_FUNCTION_KERNEL,
  HTML_MANIFEST,
  HTML_HASH,
  HTML_FUZZY,
} from '../../constants/reports';
import closeBtn from '../../images/common/close-btn.svg';
import clearBtn from '../../images/components/tag/smallCloseBtn.png';
import searchIcon from '../../images/common/search_icon.png';
import TabRowComponent from '../TabRowComponent/TabRowComponent';
import TabRowInputComponent from '../TabRowInputComponent/TabRowInputComponent';
import { getTranslatedToConstantMap, buildExportData } from '../../utils/export/exportMatchedDataBuilder';
import './MatchedModal.css';
import WithRouter from '../Extensions/WithRouter';

class MatchedModal extends Component {
  constructor(props) {
    super(props);
    this.cache = new CellMeasurerCache({
      defaultHeight: 67,
      fixedWidth: true,
    });
    this.state = {
      isOpen: props.isOpen,
      isLoading: true,
      detailedReportResponse: '',
      initDetailedReportResponse: '',
      resultData: [],
      searchKeyword: '',
      activeIndex: 0,
      isShowTruncated: {
        unique_matches: false,
        manifest_matches: false,
        hash_matches: false,
        fuzzy_matches: false,
        other_matches: false,
        no_matches: false,
        ignored: false,
        variable_name_fields: false,
        function_name_uniques: false,
        function_name_kernels: false,
      },
      currentType: '',
      uniqueStringValue: '',
      fileNameValue: '',
      versionValue: '',
      scanPathValue: '',
      activeValue: 0,
      searchType: 'all',
      selectedTabs: [],
      exportFormat: 'json',
      isAllSelected: false,
      isFetching: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearDetailedSearch = this.clearDetailedSearch.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSearchKeyPress = this.handleSearchKeyPress.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchTypeChange = this.handleSearchTypeChange.bind(this);
    this.updateUniqueCallback = this.updateUniqueCallback.bind(this);
    this.updateHashCallback = this.updateHashCallback.bind(this);
    this.updateFuzzyCallback = this.updateFuzzyCallback.bind(this);
    this.setActiveValue = this.setActiveValue.bind(this);
    this.handleTabCheck = this.handleTabCheck.bind(this);
    this.handleExportFormat = this.handleExportFormat.bind(this);
    this.handleCheckAllToggle = this.handleCheckAllToggle.bind(this);
    this.exportReportToFile = this.exportReportToFile.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .setting_popup_header .popup_name .section, .setting_popup .title, .ui.vertical.menu.fluid table tr td, .match_detail .ui.menu .item>.label, .setting_popup .setting_popup_content_wrap .ui.vertical.menu .item .ui.label', function addTitleIfOverflowing() {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { isOpen, data } = this.props;
    const { activeIndex } = this.state;

    if (isOpen !== prevProps.isOpen || prevState.activeIndex !== activeIndex) {
      localStorage.removeItem('matched_detail');

      if (isOpen !== prevProps.isOpen) {
        this.setState({
          isOpen,
          resultData: [],
          searchKeyword: '',
          activeIndex: 0,
          detailedReportResponse: data,
          initDetailedReportResponse: data,
          isShowTruncated: {
            unique_matches: false,
            manifest_matches: false,
            hash_matches: false,
            fuzzy_matches: false,
            other_matches: false,
            no_matches: false,
            ignored: false,
            variable_name_fields: false,
            function_name_uniques: false,
            function_name_kernels: false,
          },
          currentType: '',
          uniqueStringValue: '',
          fileNameValue: '',
          versionValue: '',
          scanPathValue: '',
          activeValue: 0,
          searchType: 'all',
          selectedTabs: [],
          exportFormat: 'json',
          isAllSelected: false,
          isFetching: false,
        }, () => { return isOpen && this.setInitData(data); });
      }

      if (prevState.activeIndex !== activeIndex) {
        this.setState({
          uniqueStringValue: '',
          fileNameValue: '',
          versionValue: '',
          scanPathValue: '',
        });
      }
    }
  }

  componentWillUnmount() {
  }

  handleSearchChange(e, { value }) {
    this.setState({
      searchKeyword: value,
      errSearch: false,
    });
  }

  handleSearchKeyPress(event) {
    const { activeIndex, searchType } = this.state;

    if (event.key !== 'Enter') return;

    const searchKeyword = event.target.value.trim();

    if (!searchKeyword || searchKeyword.length < 2) {
      this.setState({ errSearch: true });
      setTimeout(() => { return this.setState({ errSearch: false }); }, 1500);
      return;
    }

    this.setState({
      resultData: [],
      searchKeyword,
    }, () => {
      const tabType = this.getHtmlTabs()[activeIndex].type;
      this.fetchResults(tabType, searchType);
    });
  }

  onInitRowData() {
    const { initDetailedReportResponse } = this.state;

    this.setState({
      detailedReportResponse: initDetailedReportResponse,
    });
  }

  onUpdateRowData(key, responseData, searchKeyword) {
    const { initDetailedReportResponse, detailedReportResponse } = this.state;
    let totalCount = 0;

    if (Array.isArray(responseData) && responseData.length > 0) {
      totalCount = responseData.reduce((sum, item) => { return sum + item.component_count; }, 0);
    } else if (responseData && !Array.isArray(responseData) && searchKeyword !== '') {
      totalCount = responseData.string_array.length;
    } else {
      if (detailedReportResponse[key].count === initDetailedReportResponse[key].count) {
        return;
      }
      return this.setState({
        detailedReportResponse: initDetailedReportResponse,
      });
    }

    this.setState((prevState) => {
      return {
        detailedReportResponse: {
          ...prevState.detailedReportResponse,
          [key]: {
            ...prevState.detailedReportResponse[key],
            count: totalCount,
          },
        },
      };
    });
  }

  setInitData = (detailedReportResponse) => {
    const rawTabs = [];
    const priorityRaw = {
      unique_matches: 0,
      manifest_matches: 1,
      hash_matches: 2,
      fuzzy_matches: 3,
      other_matches: 4,
      no_matches: 5,
      ignored: 6,
      variable_field_matches: 7,
      function_kernel_matches: 8,
      function_unique_matches: 9,
    };

    Object.keys(detailedReportResponse).map((obj) => {
      if (detailedReportResponse[obj].show) {
        rawTabs.push(obj);
      }
      return false;
    });

    if (rawTabs.length === 1) {
      return this.getResultData(rawTabs[0]);
    }

    const result = rawTabs.reduce((c, n) => {
      return priorityRaw[c] < priorityRaw[n] ? c : n;
    });
    return this.getResultData(result);
  };

  getHtmlTabs() {
    const { data, translate } = this.props;
    const rawTabs = [];
    const { detailedReportResponse } = this.state;
    const tabsMapping = {
      [HTML_UNIQUE]: translate('modal.title.unique_matches'),
      [HTML_MANIFEST]: translate('modal.title.manifest_matches'),
      [HTML_HASH]: translate('modal.title.hash_matches'),
      [HTML_FUZZY]: translate('modal.title.fuzzy_matches'),
      [HTML_OTHER]: translate('modal.title.other_matches'),
      [HTML_UNMATCHED]: translate('modal.title.no_matches'),
      [HTML_IGNORE]: translate('modal.title.ignored'),
      [HTML_VARIABLE]: translate('modal.title.variable_matches'),
      [HTML_FUNCTION_UNIQUE]: translate('modal.title.function_matches'),
      [HTML_FUNCTION_KERNEL]: translate('modal.title.function_kernel_matches'),
    };
    if (data) {
      Object.keys(detailedReportResponse).map((obj) => {
        if (detailedReportResponse[obj].show && tabsMapping[obj]) {
          rawTabs.push({
            label: tabsMapping[obj],
            type: obj,
            count: detailedReportResponse[obj].count,
          });
        }
        return false;
      });
      return rawTabs;
    }
    return rawTabs;
  }

  getResultData(value) {
    const { detailedReportResponse, searchKeyword, isShowTruncated } = this.state;
    const { state } = this.props;
    const isUniqueMatch = value === 'unique_matches';
    const typeMappings = {
      unique_matches: 'unique_matches',
      manifest_matches: 'manifest_matches',
      hash_matches: 'hash_matches',
      fuzzy_matches: 'fuzzy_matches',
      other_matches: 'non_unique_matches',
      no_matches: 'un_matches',
      ignored: 'ignored',
      variable_field_matches: 'variable_name_fields',
      function_unique_matches: 'function_name_uniques',
      function_kernel_matches: 'function_name_kernels',
    };

    const obj = {
      search: searchKeyword,
      ...(state.user.currentPrecisionLevel && { precision_level: state.user.currentPrecisionLevel }),
    };

    const type = typeMappings[value] || value;

    this.setState({ isLoading: true });

    api.getMatchedDetail(obj, detailedReportResponse.uploaded_file_id, detailedReportResponse.scanned_file_id, type)
      .then((response) => {
        const res = response.data.response;

        const isTruncated = Array.isArray(res) ? res.some((item) => { return item.truncated; }) : res.truncated;
        const typeMap = {
          un_matches: 'no_matches',
          non_unique_matches: 'other_matches'
        };

        const truncatedType = typeMap[type] || type;

        const updatedIsShowTruncated = isTruncated ? { ...isShowTruncated, [truncatedType]: true } : isShowTruncated;

        if (isUniqueMatch || type === 'manifest_matches' || type === 'hash_matches') {
          const matchCounts = ['manifest_matches', 'hash_matches'].map((matchType) => {
            return {
              type: matchType,
              count: detailedReportResponse[matchType]?.count || 0,
            };
          }).filter((match) => { return match.count > 0; });

          if (matchCounts.length === 2 && matchCounts.reduce((acc, cur) => { return acc + cur.count; }, 0) > 70000) {
            updatedIsShowTruncated.manifest_matches = true;
            updatedIsShowTruncated.hash_matches = true;
          }
        }

        this.setState({
          isLoading: false,
          resultData: res,
          isShowTruncated: updatedIsShowTruncated,
          currentType: value,
        }, () => { return this.onUpdateRowData(value, res, searchKeyword); });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  getResultDataWithComponent(value) {
    const { detailedReportResponse, searchKeyword, isShowTruncated } = this.state;
    const { state } = this.props;

    const obj = {
      component: searchKeyword,
      ...(state.user.currentPrecisionLevel && { precision_level: state.user.currentPrecisionLevel }),
    };

    const typeMapping = {
      unique_matches: 'unique_matches',
      manifest_matches: 'manifest_matches',
      hash_matches: 'hash_matches',
      fuzzy_matches: 'fuzzy_matches',
      other_matches: 'non_unique_matches',
      no_matches: 'un_matches',
      ignored: 'ignored',
      variable_field_matches: 'variable_name_fields',
      function_unique_matches: 'function_name_uniques',
      function_kernel_matches: 'function_name_kernels',
    };
    const type = typeMapping[value] || value;

    this.setState({ isLoading: true });

    api.getMatchedDetail(obj, detailedReportResponse.uploaded_file_id, detailedReportResponse.scanned_file_id, type)
      .then((response) => {
        const res = response.data.response;
        let truncatedNumber = 0;

        if (Array.isArray(res)) {
          truncatedNumber = res.filter((item) => { return item.truncated; }).length;
        } else if (res.truncated) {
          truncatedNumber = 1;
        }

        const updatedTruncatedObj = { ...isShowTruncated };

        if (truncatedNumber > 0) {
          updatedTruncatedObj[type] = true;
        }

        this.setState({
          isLoading: false,
          resultData: res,
          isShowTruncated: updatedTruncatedObj,
          currentType: value,
        }, () => {
          this.onUpdateRowData(value, res, searchKeyword);
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
      });
  }

  getUniqueDetail() {
    const {
      resultData,
      isLoading,
      uniqueStringValue,
      fileNameValue,
      versionValue,
      scanPathValue,
      isOpen,
      activeValue
    } = this.state;

    const { translate } = this.props;
    let innerItem;
    if (resultData.length !== 0 && !isLoading) {
      innerItem = resultData.map((tab, index) => {
        return {
          menuItem: (
            <Menu.Item key={tab.component_name.toString()}>
              <table style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '60%' }} />
                  <col style={{ width: '40%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td colSpan="2">
                      <h4 style={{
                        lineHeight: '20px', fontSize: '22px', fontWeight: 'bold', color: '#7434fe'
                      }}
                      >
                        {tab.component_percentage}
                        %
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style={{
                        lineHeight: '19px', fontSize: '16px', fontWeight: '500', color: '#4a4a4a'
                      }}
                      >
                        {tab.component_name}
                      </span>
                    </td>
                    <td>
                      {
                        tab.truncated ? (
                          <Label style={{ color: '#fe6734' }}>{this.numberWithCommas(tab.component_count)}</Label>
                        ) : (
                          <Label>{this.numberWithCommas(tab.component_count)}</Label>
                        )
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </Menu.Item>
          ),
          render: () => {
            return (
              <Tab.Pane key={uuidv4()}>
                <div className="table_wrap table_type_3" style={{ height: '500px' }}>
                  <TabRowInputComponent
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...this.props}
                    isOpen={isOpen}
                    currentIndex={index}
                    activeValue={activeValue}
                    translate={translate}
                    matchesData={tab.unique_matches}
                    uniqueStringValue={uniqueStringValue}
                    scanPathValue={scanPathValue}
                    fileNameValue={fileNameValue}
                    versionValue={versionValue}
                    versionCount={tab.version_count ?? 0}
                    crawledFileNameCount={tab.crawled_file_name_count ?? 0}
                    lineNumberCount={tab.line_number_count ?? 0}
                    scannedFileNameCount={tab.scanned_file_name_count ?? 0}
                    componentCount={tab.component_count ?? 0}
                    updateUniqueCallback={this.updateUniqueCallback}
                    clearDetailedSearch={this.clearDetailedSearch}
                    setActiveValue={this.setActiveValue}
                  />
                </div>
              </Tab.Pane>
            );
          },
        };
      });
    } else if (resultData.length === 0 && !isLoading) {
      innerItem = [{ menuItem: translate('modal.message.no_results_found'), render: () => { return <Tab.Pane>{translate('modal.message.no_results_found')}</Tab.Pane>; } }];
    } else {
      innerItem = [{ menuItem: translate('modal.message.loading'), render: () => { return <Tab.Pane loading>{translate('modal.message.loading')}</Tab.Pane>; } }];
    }
    return innerItem;
  }

  getFuzzyDetail() {
    const {
      resultData,
      isLoading,
      fileNameValue,
      versionValue,
      isOpen,
      activeValue,
      scanPathValue
    } = this.state;

    const { translate } = this.props;
    let innerItem;
    if (resultData.length !== 0 && !isLoading) {
      innerItem = resultData.map((tab, index) => {
        return {
          menuItem: (
            <Menu.Item key={tab.component_name.toString()}>
              <table style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '60%' }} />
                  <col style={{ width: '40%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <span style={{
                        lineHeight: '19px', fontSize: '16px', fontWeight: '500', color: '#4a4a4a'
                      }}
                      >
                        {tab.component_name}
                      </span>
                    </td>
                    <td>
                      {
                        tab.truncated ? (
                          <Label style={{ color: '#fe6734' }}>{this.numberWithCommas(tab.component_count)}</Label>
                        ) : (
                          <Label>{this.numberWithCommas(tab.component_count)}</Label>
                        )
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </Menu.Item>
          ),
          render: () => {
            return (
              <Tab.Pane key={uuidv4()}>
                <div className="table_wrap table_type_3" style={{ height: '500px' }}>
                  <TabRowComponent
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...this.props}
                    isOpen={isOpen}
                    activeValue={activeValue}
                    currentIndex={index}
                    translate={translate}
                    matchesData={tab.fuzzy_matches}
                    fileNameValue={fileNameValue}
                    versionValue={versionValue}
                    scanPathValue={scanPathValue}
                    versionCount={tab.version_count ?? 0}
                    crawledFileNameCount={tab.crawled_file_name_count ?? 0}
                    hashCount={tab.sha256_count ?? 0}
                    scannedFileNameCount={tab.scanned_file_name_count ?? 0}
                    componentCount={tab.component_count ?? 0}
                    updateHashCallback={this.updateFuzzyCallback}
                    clearDetailedSearch={this.clearDetailedSearch}
                    currentTab="fuzzy_matches"
                    setActiveValue={this.setActiveValue}
                  />
                </div>
              </Tab.Pane>
            );
          },
        };
      });
    } else if (resultData.length === 0 && !isLoading) {
      innerItem = [{ menuItem: translate('modal.message.no_results_found'), render: () => { return <Tab.Pane>{translate('modal.message.no_results_found')}</Tab.Pane>; } }];
    } else {
      innerItem = [{ menuItem: translate('modal.message.loading'), render: () => { return <Tab.Pane loading>{translate('modal.message.loading')}</Tab.Pane>; } }];
    }
    return innerItem;
  }

  getManifestDetail() {
    const { resultData, isLoading } = this.state;
    const { translate } = this.props;
    let innerItem;
    if (resultData.length !== 0) {
      innerItem = resultData.map((tab) => {
        const manifestArray = tab.manifest_matches.manifest_array;
        const list = manifestArray.length !== 0 ? manifestArray : [];

        const rowRenderer = ({
          key, index, style, parent
        }) => {
          const rowData = list[index];
          return (
            <CellMeasurer
              cache={this.cache}
              columnIndex={0}
              key={key}
              parent={parent}
              rowIndex={index}
              onLoad={this.debouncedMeasure}
            >
              {() => {
                return (
                  <div style={style} className="table-cell-one-row">
                    <pre>{rowData}</pre>
                  </div>
                );
              }}
            </CellMeasurer>
          );
        };

        return {
          menuItem: (
            <Menu.Item key={tab.component_name.toString()}>
              <table style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '60%' }} />
                  <col style={{ width: '40%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <span style={{
                        lineHeight: '19px', fontSize: '16px', fontWeight: '500', color: '#4a4a4a'
                      }}
                      >
                        {tab.component_name}
                      </span>
                    </td>
                    <td>
                      {
                        tab.truncated ? (
                          <Label style={{ color: '#fe6734' }}>{this.numberWithCommas(tab.component_count)}</Label>
                        ) : (
                          <Label>{this.numberWithCommas(tab.component_count)}</Label>
                        )
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </Menu.Item>
          ),
          render: () => {
            return (
              <Tab.Pane key={uuidv4()}>
                <div className="table_wrap table_type_3" style={{ height: '500px' }}>

                  {
                    tab.manifest_matches
                      && (
                        <AutoSizer>
                          {({ width, height }) => {
                            return (
                              <Table
                                width={width}
                                height={height}
                                headerHeight={20}
                                deferredMeasurementCache={this.cache}
                                rowHeight={this.getRowHeight}
                                rowCount={list.length}
                                rowGetter={({ index }) => { return list[index]; }}
                                rowRenderer={rowRenderer}
                              >
                                <Column
                                  label={tab.manifest_matches.label}
                                  dataKey="value"
                                  width={width}
                                  headerRenderer={() => {
                                    return (
                                      <div className="table-cell-header">
                                        <span>{tab.manifest_matches.label}</span>
                                      </div>
                                    );
                                  }}
                                  // eslint-disable-next-line no-unused-vars
                                  cellRenderer={({ cellData, rowData }) => {
                                    return (
                                      <div className="table-cell-one-row">
                                        {rowData}
                                      </div>
                                    );
                                  }}
                                />
                              </Table>
                            );
                          }}
                        </AutoSizer>
                      )
                  }
                </div>
              </Tab.Pane>
            );
          },
        };
      });
    } else if (resultData.length === 0 && !isLoading) {
      innerItem = [{ menuItem: translate('modal.message.no_results_found'), render: () => { return <Tab.Pane>{translate('modal.message.no_results_found')}</Tab.Pane>; } }];
    } else {
      innerItem = [{ menuItem: translate('modal.message.loading'), render: () => { return <Tab.Pane loading>{translate('modal.message.loading')}</Tab.Pane>; } }];
    }
    return innerItem;
  }

  getHashDetail() {
    const {
      resultData, isLoading, fileNameValue, versionValue, isOpen, activeValue, scanPathValue
    } = this.state;
    const { translate } = this.props;

    let innerItem;
    if (resultData.length !== 0) {
      innerItem = resultData.map((tab, index) => {
        return {
          menuItem: (
            <Menu.Item key={tab.component_name.toString()}>
              <table style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '60%' }} />
                  <col style={{ width: '40%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <span style={{
                        lineHeight: '19px', fontSize: '16px', fontWeight: '500', color: '#4a4a4a'
                      }}
                      >
                        {tab.component_name}
                      </span>
                    </td>
                    <td>
                      {
                        tab.truncated ? (
                          <Label style={{ color: '#fe6734' }}>{this.numberWithCommas(tab.component_count)}</Label>
                        ) : (
                          <Label>{this.numberWithCommas(tab.component_count)}</Label>
                        )
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </Menu.Item>
          ),
          render: () => {
            return (
              <Tab.Pane key={uuidv4()}>
                <div className="table_wrap table_type_3" style={{ height: '500px' }}>
                  <TabRowComponent
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...this.props}
                    isOpen={isOpen}
                    activeValue={activeValue}
                    currentIndex={index}
                    translate={translate}
                    matchesData={tab.hash_matches}
                    scanPathValue={scanPathValue}
                    fileNameValue={fileNameValue}
                    versionValue={versionValue}
                    versionCount={tab.version_count ?? 0}
                    crawledFileNameCount={tab.crawled_file_name_count ?? 0}
                    hashCount={tab.sha256_count ?? 0}
                    scannedFileNameCount={tab.scanned_file_name_count ?? 0}
                    componentCount={tab.component_count ?? 0}
                    updateHashCallback={this.updateHashCallback}
                    clearDetailedSearch={this.clearDetailedSearch}
                    currentTab="hash_matches"
                    setActiveValue={this.setActiveValue}
                  />
                </div>
              </Tab.Pane>
            );
          },
        };
      });
    } else if (resultData.length === 0 && !isLoading) {
      innerItem = [{ menuItem: translate('modal.message.no_results_found'), render: () => { return <Tab.Pane>{translate('modal.message.no_results_found')}</Tab.Pane>; } }];
    } else {
      innerItem = [{ menuItem: translate('modal.message.loading'), render: () => { return <Tab.Pane loading>{translate('modal.message.loading')}</Tab.Pane>; } }];
    }
    return innerItem;
  }

  getOtherDetail() {
    const { resultData, isLoading } = this.state;
    const { translate } = this.props;

    let innerItem;
    if (resultData.length !== 0) {
      innerItem = resultData.map((tab) => {
        return {
          menuItem: (
            <Menu.Item key={tab.component_name.toString()}>
              <table style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '60%' }} />
                  <col style={{ width: '40%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <span style={{
                        lineHeight: '19px', fontSize: '16px', fontWeight: '500', color: '#4a4a4a'
                      }}
                      >
                        {tab.component_name}
                      </span>
                    </td>
                    <td><Label>{this.numberWithCommas(tab.component_count)}</Label></td>
                  </tr>
                </tbody>
              </table>
            </Menu.Item>
          ),
          render: () => {
            return (
              <Tab.Pane key={uuidv4()}>
                <div className="table_wrap table_type_3" style={{ height: '500px' }}>
                  {
                    tab.other_matches && (
                      <>
                        <div className="table-cell-header">
                          <span>{tab.other_matches.label}</span>
                        </div>
                        <AutoSizer>
                          {({ width, height }) => {
                            const stringArray = tab.other_matches.string_array;
                            return (
                              <List
                                width={width}
                                height={height}
                                rowCount={stringArray.length}
                                deferredMeasurementCache={this.cache}
                                rowHeight={this.getRowHeight}
                                rowRenderer={({
                                  key, index, style, parent
                                }) => {
                                  const rowData = stringArray[index];
                                  return (
                                    <CellMeasurer
                                      key={key}
                                      cache={this.cache}
                                      columnIndex={0}
                                      parent={parent}
                                      rowIndex={index}
                                      onLoad={this.debouncedMeasure}
                                    >
                                      {({ measure }) => {
                                        return (
                                          <div key={key} style={style} className="table-cell-one-row">
                                            <pre
                                              ref={(el) => {
                                                if (el) {
                                                  requestAnimationFrame(() => {
                                                    if (document.body.contains(el)) {
                                                      try {
                                                        measure();
                                                      } catch (e) {
                                                        console.error('Measurement error:', e);
                                                      }
                                                    }
                                                  });
                                                }
                                              }}
                                            >
                                              {rowData}
                                            </pre>
                                          </div>
                                        );
                                      }}
                                    </CellMeasurer>
                                  );
                                }}
                              />
                            );
                          }}
                        </AutoSizer>
                      </>
                    )
                  }
                  {
                    tab.unique_matches && (
                      <>
                        <div className="table-cell-header" style={{ marginTop: '16px' }}>
                          <span>{tab.unique_matches.label}</span>
                        </div>
                        <AutoSizer>
                          {({ width, height }) => {
                            const stringArray = tab.unique_matches.string_array;
                            return (
                              <List
                                width={width}
                                height={height}
                                rowCount={stringArray.length}
                                deferredMeasurementCache={this.cache}
                                rowHeight={this.getRowHeight}
                                rowRenderer={({
                                  key, index, style, parent
                                }) => {
                                  const rowData = stringArray[index];
                                  return (
                                    <CellMeasurer
                                      key={key}
                                      cache={this.cache}
                                      columnIndex={0}
                                      parent={parent}
                                      rowIndex={index}
                                      onLoad={this.debouncedMeasure}
                                    >
                                      {({ measure }) => {
                                        return (
                                          <div key={key} style={style} className="table-cell-one-row">
                                            <pre
                                              ref={(el) => {
                                                if (el) {
                                                  requestAnimationFrame(() => {
                                                    if (document.body.contains(el)) {
                                                      try {
                                                        measure();
                                                      } catch (e) {
                                                        console.error('Measurement error:', e);
                                                      }
                                                    }
                                                  });
                                                }
                                              }}
                                            >
                                              {rowData}
                                            </pre>
                                          </div>
                                        );
                                      }}
                                    </CellMeasurer>
                                  );
                                }}
                              />
                            );
                          }}
                        </AutoSizer>
                      </>
                    )
                  }
                </div>
              </Tab.Pane>
            );
          },
        };
      });
    } else if (resultData.length === 0 && !isLoading) {
      innerItem = [{ menuItem: translate('modal.message.no_results_found'), render: () => { return <Tab.Pane>{translate('modal.message.no_results_found')}</Tab.Pane>; } }];
    } else {
      innerItem = [{ menuItem: translate('modal.message.loading'), render: () => { return <Tab.Pane loading>{translate('modal.message.loading')}</Tab.Pane>; } }];
    }
    return innerItem;
  }

  getRowHeight = ({ index }) => {
    return this.cache.rowHeight({ index }) || 67;
  };

  getNoDetail() {
    const { resultData, isLoading } = this.state;
    const { translate } = this.props;

    if (resultData.string_array && resultData.string_array.length !== 0 && !isLoading) {
      const stringArray = resultData.string_array;

      return (
        <div className="table_wrap table_type_3" style={{ height: '500px' }}>
          <div className="table-cell-header">
            <span>{resultData.label}</span>
          </div>
          <AutoSizer>
            {({ width, height }) => {
              return (
                <List
                  width={width}
                  height={height}
                  rowCount={stringArray.length}
                  deferredMeasurementCache={this.cache}
                  rowHeight={this.cache.rowHeight}
                  rowRenderer={({
                    index, key, style, parent
                  }) => {
                    const rowData = stringArray[index];
                    return (
                      <CellMeasurer
                        key={key}
                        cache={this.cache}
                        columnIndex={0}
                        parent={parent}
                        rowIndex={index}
                      >
                        {({ measure }) => {
                          return (
                            <div key={key} style={style} className="table-cell-one-row">
                              <pre
                                ref={(el) => {
                                  if (el) {
                                    requestAnimationFrame(() => {
                                      if (document.body.contains(el)) {
                                        try {
                                          measure();
                                        } catch (e) {
                                          console.error('Measurement error:', e);
                                        }
                                      }
                                    });
                                  }
                                }}
                              >
                                {rowData}
                              </pre>
                            </div>
                          );
                        }}
                      </CellMeasurer>
                    );
                  }}
                />
              );
            }}
          </AutoSizer>
        </div>
      );
    } if (resultData.string_array && resultData.string_array.length === 0 && !isLoading) {
      return (
        <div className="table_wrap table_type_3" style={{ height: '500px' }}>
          <Scrollbars
            renderTrackHorizontal={() => {
              return <div />;
            }}
            renderThumbHorizontal={() => {
              return <div />;
            }}
          >
            <table className="table table_type_3">
              <colgroup>
                <col style={{ width: '' }} />
              </colgroup>
              <tbody>
                <tr>
                  {translate('modal.message.no_results_found')}
                </tr>
              </tbody>
            </table>
          </Scrollbars>
        </div>
      );
    }
    return (
      <Tab.Pane loading>{translate('modal.message.loading')}</Tab.Pane>
    );
  }

  setActiveValue(value, string) {
    const { activeValue } = this.state;

    if (activeValue === value) {
      return;
    }

    this.clearDetailedSearch(string);

    this.setState({
      activeValue: value,
    });
  }

  debouncedMeasure = () => {
    if (this.measureTimeout) {
      clearTimeout(this.measureTimeout);
    }
    this.measureTimeout = setTimeout(() => {
      this.forceUpdate();
    }, 100);
  };

  updateUniqueCallback = (obj) => {
    const updateState = (updatePath, value = null) => {
      this.setState((prevState) => {
        return {
          resultData: Update(prevState.resultData, {
            [obj.index]: updatePath,
          }),
          ...value,
        };
      });
    };

    const path = { unique_matches: { $set: obj.update_data } };
    const backupDataPath = { unique_matches: { $set: obj.backup_data } };

    switch (obj.type) {
    case 'unique_string':
      updateState(path, { uniqueStringValue: obj.value });
      break;
    case 'version':
      updateState(path, { versionValue: obj.value });
      break;
    case 'crawled_file':
      updateState(path, { fileNameValue: obj.value });
      break;
    case 'scanned_file':
      updateState(path, { scanPathValue: obj.value });
      break;
    case 'all':
      updateState(backupDataPath);
      break;
    default:
      break;
    }

    const originalList = JSON.parse(localStorage.getItem('matched_detail')) || [];
    if (!originalList.some((item) => { return item.index === obj.index; })) {
      originalList.push({
        index: obj.index,
        data: obj.backup_data,
      });
      localStorage.setItem('matched_detail', JSON.stringify(originalList));
    }
  };

  updateHashCallback = (obj) => {
    const updateState = (updatePath, value = null) => {
      this.setState((prevState) => {
        return {
          resultData: Update(prevState.resultData, {
            [obj.index]: updatePath,
          }),
          ...value,
        };
      });
    };
    const path = { hash_matches: { $set: obj.update_data } };
    const backupDataPath = { hash_matches: { $set: obj.backup_data } };

    switch (obj.type) {
    case 'version':
      updateState(path, { versionValue: obj.value });
      break;
    case 'crawled_file':
      updateState(path, { fileNameValue: obj.value });
      break;
    case 'scanned_file':
      updateState(path, { scanPathValue: obj.value });
      break;
    case 'all':
      updateState(backupDataPath);
      break;
    default:
      break;
    }

    const originalList = JSON.parse(localStorage.getItem('matched_detail')) || [];
    if (!originalList.some((item) => { return item.index === obj.index; })) {
      originalList.push({
        index: obj.index,
        data: obj.backup_data,
      });
      localStorage.setItem('matched_detail', JSON.stringify(originalList));
    }
  };

  updateFuzzyCallback = (obj) => {
    const updateState = (updatePath, value = {}) => {
      this.setState((prevState) => {
        return {
          resultData: Update(prevState.resultData, {
            [obj.index]: updatePath,
          }),
          ...value,
        };
      });
    };

    const path = { fuzzy_matches: { $set: obj.update_data } };
    const backupDataPath = { fuzzy_matches: { $set: obj.backup_data } };

    switch (obj.type) {
    case 'version':
      updateState(path, { versionValue: obj.value });
      break;
    case 'crawled_file':
      updateState(path, { fileNameValue: obj.value });
      break;
    case 'scanned_file':
      updateState(path, { scanPathValue: obj.value });
      break;
    case 'all':
      updateState(backupDataPath);
      break;
    default:
      break;
    }

    const originalList = JSON.parse(localStorage.getItem('matched_detail')) || [];
    const indexExists = originalList.some((item) => { return item.index === obj.index; });

    if (!indexExists) {
      originalList.push({
        index: obj.index,
        data: obj.backup_data,
      });
      localStorage.setItem('matched_detail', JSON.stringify(originalList));
    }
  };

  fetchTabData = async (tabId) => {
    const { detailedReportResponse } = this.state;
    const { state } = this.props;

    const typeMappings = {
      unique_matches: 'unique_matches',
      manifest_matches: 'manifest_matches',
      hash_matches: 'hash_matches',
      fuzzy_matches: 'fuzzy_matches',
      other_matches: 'non_unique_matches',
      no_matches: 'un_matches',
      ignored: 'ignored',
      variable_field_matches: 'variable_name_fields',
      function_unique_matches: 'function_name_uniques',
      function_kernel_matches: 'function_name_kernels',
    };

    const type = typeMappings[tabId] || tabId;

    const obj = {
      ...(state.user.currentPrecisionLevel && { precision_level: state.user.currentPrecisionLevel }),
    };

    try {
      const res = await api.getMatchedDetail(obj, detailedReportResponse.uploaded_file_id, detailedReportResponse.scanned_file_id, type);
      const data = res.data.response;

      return data;
    } catch (err) {
      console.log(err);
      this.setState({
        isFetching: false,
      });
      throw err;
    }

  };

  exportReportToExcel = async () => {
    const { translate, precisionLevel } = this.props;
    const {
      selectedTabs,
      exportFormat,
      detailedReportResponse,
    } = this.state;

    const {
      scanned_file_name,
      scanned_file_id,
      uploaded_file_id,
    } = detailedReportResponse;

    const map = getTranslatedToConstantMap(translate);
    let filter = '';

    selectedTabs.map((tabLabel, index) => {
      const tabId = map[tabLabel];
      if (index === 0) {
        filter = tabId;
        return filter;
      }
      filter = `${filter}, ${tabId}`;
      return filter;
    });

    const obj = {
      file_format: exportFormat,
      filter,
      precision_level: precisionLevel,
    };

    api
      .getExportMatchedReport(uploaded_file_id, scanned_file_id, obj)
      .then((res) => {
        this.setState({
          isFetching: false,
        });
        const fileName = `${scanned_file_name}_report.xlsx`;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, fileName);
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isFetching: false,
        });
      });

  };

  exportReportToFile = async () => {
    const { translate } = this.props;
    const {
      selectedTabs, exportFormat, activeIndex, resultData, detailedReportResponse
    } = this.state;

    const {
      project_name,
      project_version_name,
      uploaded_file_name,
      scanned_file_name,
      uploaded_file_id,
    } = detailedReportResponse;

    this.setState({
      isFetching: true,
    });

    if (exportFormat === 'excel') {
      return this.exportReportToExcel();
    }

    let overviewData = null;

    try {
      const res = await api.getOverviewSummaryDetail(uploaded_file_id);
      overviewData = res.response;
    } catch (err) {
      console.error('[overview fetch error]', err);
      overviewData = {
        owner: null,
        current_precision_level: null,
        uploaded_at: null,
      };
    }

    let confidenceLevel;

    if (overviewData.current_precision_level === 'broad') {
      confidenceLevel = 'low';
    } else if (overviewData.current_precision_level === 'narrow') {
      confidenceLevel = 'high';
    } else if (overviewData.current_precision_level === 'medium') {
      confidenceLevel = 'medium';
    } else {
      confidenceLevel = 'unknown';
    }

    const map = getTranslatedToConstantMap(translate);
    const analysisInfo = {
      scan_owner: overviewData.owner,
      project_name,
      project_version: project_version_name,
      uploaded_file_name,
      scanned_file_name,
      confidence_level: confidenceLevel,
      created: new Date().toISOString(),
      uploaded_at: overviewData.uploaded_at,
      vendor: 'Insignary',
      product: 'Clarity'
    };

    const tabDataMap = {};

    const promises = selectedTabs.map(async (tabLabel) => {
      const tabId = map[tabLabel];
      const activeTabId = this.getHtmlTabs()[activeIndex].type;

      if (activeTabId === tabId) {
        tabDataMap[tabId] = resultData;
      } else {
        tabDataMap[tabId] = await this.fetchTabData(tabId);
      }
    });

    await Promise.all(promises);

    const jsonString = buildExportData({
      tabDataMap,
      analysisInfo,
      exportFormat,
    });

    const blob = new Blob([jsonString], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${scanned_file_name}_report.json`;
    link.click();

    this.setState({
      isFetching: false,
    });
  };

  handleTabChange = (e, data) => {
    const { activeIndex } = this.state;

    if (data.activeIndex !== activeIndex) {
      localStorage.removeItem('matched_detail');

      this.setState({
        activeIndex: data.activeIndex,
        resultData: [],
        searchType: 'all',
        errSearch: false,
        fileNameValue: '',
        versionValue: '',
        uniqueStringValue: '',
        scanPathValue: '',
      }, () => {
        this.onInitRowData();
        this.getResultData(this.getHtmlTabs()[data.activeIndex].type);
      });
    }
  };

  handleSearchTypeChange = (e, data) => {
    const { searchType } = this.state;

    if (data.value === searchType) {
      return;
    }

    this.setState({
      searchType: data.value
    });
  };

  handleTabCheck = (label) => {
    const tabInfos = this.getHtmlTabs();
    const allLabels = tabInfos.map((tab) => { return tab.label; });

    this.setState((prevState) => {
      const { selectedTabs } = prevState;
      const isSelected = selectedTabs.includes(label);

      const newSelectedTabs = isSelected
        ? selectedTabs.filter((item) => { return item !== label; })
        : [...selectedTabs, label];

      const isAllSelected = newSelectedTabs.length === allLabels.length;

      return {
        selectedTabs: newSelectedTabs,
        isAllSelected,
      };
    });
  };

  handleExportFormat = (e, { value }) => {
    const { exportFormat } = this.state;

    if (exportFormat === value) {
      return;
    }

    this.setState({
      exportFormat: value,
    });
  };

  handleCheckAllToggle = () => {
    const tabInfos = this.getHtmlTabs();
    const allLabels = tabInfos.map((tab) => { return tab.label; });

    this.setState((prevState) => {
      const { isAllSelected } = prevState;

      const newIsAllSelected = !isAllSelected;
      const newSelectedTabs = newIsAllSelected ? allLabels : [];

      return {
        isAllSelected: newIsAllSelected,
        selectedTabs: newSelectedTabs,
      };
    });
  };

  fetchResults(tabType, searchType) {
    localStorage.removeItem('matched_detail');
    if (searchType === 'all') {
      this.getResultData(tabType);
    } else {
      this.getResultDataWithComponent(tabType);
    }
  }

  numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  clearSearch() {
    const { activeIndex, searchKeyword } = this.state;

    if (searchKeyword === '') {
      return;
    }

    localStorage.removeItem('matched_detail');

    this.setState({
      searchKeyword: '',
      uniqueStringValue: '',
      fileNameValue: '',
      scanPathValue: '',
      versionValue: '',
      resultData: [],
    }, () => {
      this.getResultData(this.getHtmlTabs()[activeIndex].type);
    });
  }

  clearDetailedSearch(string) {
    if (localStorage.getItem('matched_detail') === null) {
      return;
    }

    const originalList = JSON.parse(localStorage.getItem('matched_detail'));
    const { resultData } = this.state;

    const updateCommand = originalList.reduce((acc, item) => {
      acc[item.index] = { [string]: { $set: item.data } };
      return acc;
    }, {});

    const newData = Update(resultData, updateCommand);

    localStorage.removeItem('matched_detail');

    this.setState({
      resultData: newData,
      uniqueStringValue: '',
      fileNameValue: '',
      scanPathValue: '',
      versionValue: '',
    });
  }

  closeModal(e) {
    const { closeModal } = this.props;
    if (e.target.classList[0] === 'has_link') {
      return;
    }
    this.setState({
      isOpen: false,
    });
    closeModal();
  }

  render() {
    const {
      detailedReportResponse,
      errSearch,
      isShowTruncated,
      searchKeyword,
      currentType,
      isOpen,
      searchType,
      selectedTabs,
      exportFormat,
      isAllSelected,
      isFetching,
    } = this.state;
    const { translate } = this.props;

    const search_options = [
      { key: 1, text: translate('modal.message.search_component'), value: 'component' },
      { key: 2, text: translate('modal.message.search_all'), value: 'all' },
    ];

    const format_options = [
      { key: 'json', text: 'JSON', value: 'json' },
      //{ key: 'csv', text: 'CSV', value: 'csv' },
      { key: 'excel', text: 'Excel', value: 'excel' }
    ];

    const result = this.getHtmlTabs().map((tab) => {
      return {
        menuItem: (
          <Menu.Item key={tab.label.toString()}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'nowrap'
            }}
            >
              <Checkbox
                checked={selectedTabs.includes(tab.label)}
                value={tab.label}
                onChange={(e) => {
                  e.stopPropagation();
                  this.handleTabCheck(tab.label);
                }}
              />

              {isShowTruncated[tab.type] ? (
                <div>
                  {tab.label}
                  <Popup
                    trigger={(
                      <Label>
                        <span style={{ color: '#fe6734' }}>
                          {this.numberWithCommas(tab.count)}
                        </span>
                      </Label>
                    )}
                    inverted
                    position="bottom left"
                  >
                    <SemanticList>
                      <SemanticList.Item>
                        <span className="tip">
                          {translate('modal.title.truncated_info')}
                        </span>
                      </SemanticList.Item>
                    </SemanticList>
                  </Popup>
                </div>
              ) : (
                <div>
                  {tab.label}
                  <Label>
                    <span>{this.numberWithCommas(tab.count)}</span>
                  </Label>
                </div>
              )}
            </div>
          </Menu.Item>
        ),
        render: () => {
          return (
            <Tab.Pane>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    {
                      tab.label === translate('modal.title.unique_matches')
                      && (
                        <table className="table">
                          <colgroup>
                            <col style={{ width: '205px' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <Tab defaultActiveIndex={0} menu={{ fluid: true, vertical: true, tabular: true }} panes={this.getUniqueDetail()} />
                            </tr>
                          </tbody>
                        </table>
                      )
                    }
                    {
                      tab.label === translate('modal.title.manifest_matches')
                    && (
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '205px' }} />
                          <col style={{ width: '' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <Tab defaultActiveIndex={0} menu={{ fluid: true, vertical: true, tabular: true }} panes={this.getManifestDetail()} />
                          </tr>
                        </tbody>
                      </table>
                    )
                    }
                    {
                      tab.label === translate('modal.title.hash_matches')
                    && (
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '205px' }} />
                          <col style={{ width: '' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <Tab defaultActiveIndex={0} menu={{ fluid: true, vertical: true, tabular: true }} panes={this.getHashDetail()} />
                          </tr>
                        </tbody>
                      </table>
                    )
                    }
                    {
                      tab.label === translate('modal.title.fuzzy_matches')
                      && (
                        <table className="table">
                          <colgroup>
                            <col style={{ width: '205px' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <Tab defaultActiveIndex={0} menu={{ fluid: true, vertical: true, tabular: true }} panes={this.getFuzzyDetail()} />
                            </tr>
                          </tbody>
                        </table>
                      )
                    }
                    {
                      tab.label === translate('modal.title.other_matches')
                      && (
                        <table className="table">
                          <colgroup>
                            <col style={{ width: '205px' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <Tab defaultActiveIndex={0} menu={{ fluid: true, vertical: true, tabular: true }} panes={this.getOtherDetail()} />
                            </tr>
                          </tbody>
                        </table>
                      )
                    }
                    {
                      tab.label === translate('modal.title.no_matches')
                      && (
                        <div className="table_wrap table_type_3">
                          {this.getNoDetail()}
                        </div>
                      )
                    }
                    {
                      tab.label === translate('modal.title.ignored')
                      && (
                        <div className="table_wrap table_type_3">
                          {this.getNoDetail()}
                        </div>
                      )
                    }
                    {
                      tab.label === translate('modal.title.variable_matches')
                      && (
                        <div className="table_wrap table_type_3">
                          {this.getNoDetail()}
                        </div>
                      )
                    }
                    {
                      tab.label === translate('modal.title.function_matches')
                      && (
                        <table className="table">
                          <colgroup>
                            <col style={{ width: '205px' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <Tab defaultActiveIndex={0} menu={{ fluid: true, vertical: true, tabular: true }} panes={this.getOtherDetail()} />
                            </tr>
                          </tbody>
                        </table>
                      )
                    }
                    {
                      tab.label === translate('modal.title.function_kernel_matches')
                      && (
                        <div className="table_wrap table_type_3">
                          {this.getNoDetail()}
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </Tab.Pane>
          );
        },
      };
    });

    return (
      <Modal
        open={isOpen}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap">
          <div
            className="setting_popup default_popup has_setting_popup_tab match_detail"
            style={{ paddingTop: '30px', paddingBottom: '45px', height: '795px' }}
          >
            <Container style={{ paddingTop: '0', position: 'relative' }}>
              <Header as="h2">
                <Popup
                  trigger={(
                    <Icon
                      className="header_icon"
                      name="question circle outline"
                    />
                  )}
                  inverted
                  position="bottom left"
                  style={{ width: '200px' }}
                >
                  <SemanticList>
                    <SemanticList.Item>
                      <SemanticList.Icon name="circle" style={{ color: '#fe6734', fontSize: '11px' }} />
                      <span className="tip truncated">{translate('modal.title.truncated_count')}</span>
                    </SemanticList.Item>
                    <SemanticList.Item>
                      <SemanticList.Icon name="circle" style={{ color: '#00000099', fontSize: '11px' }} />
                      <span className="tip truncated">{translate('modal.title.real_count')}</span>
                    </SemanticList.Item>
                  </SemanticList>
                </Popup>
                <Header.Content
                  className="header_title"
                >
                  {translate('list.title.matched_detail')}
                </Header.Content>
                <Breadcrumb
                  size="tiny"
                  style={{
                    display: 'table-cell', paddingLeft: '6px', paddingTop: '9px', color: '#777'
                  }}
                >
                  <Breadcrumb.Section>{detailedReportResponse.project_name}</Breadcrumb.Section>
                  <Breadcrumb.Divider>/</Breadcrumb.Divider>
                  <Breadcrumb.Section>{detailedReportResponse.project_version_name}</Breadcrumb.Section>
                  <Breadcrumb.Divider>/</Breadcrumb.Divider>
                  <Breadcrumb.Section>{detailedReportResponse.uploaded_file_name}</Breadcrumb.Section>
                  <Breadcrumb.Divider>/</Breadcrumb.Divider>
                </Breadcrumb>
              </Header>
              <Header as="h4" style={{ padding: '10px 0 0 3px' }}>
                <Icon className="file outline" />
                {detailedReportResponse.scanned_file_name}
              </Header>
              <a
                className="popup_close_button"
                style={{ cursor: 'pointer', top: '5px' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </Container>
            <div className="matched-container">
              <div className="search-section">
                <div
                  className="search_box"
                >
                  <Input
                    className="text left icon"
                    focus
                    error={errSearch}
                    placeholder={translate('modal.message.type_text_search')}
                    value={searchKeyword}
                    onChange={this.handleSearchChange}
                    onKeyPress={this.handleSearchKeyPress}
                  >
                    <span className="search_icon">
                      <img src={searchIcon} alt="" />
                    </span>
                    <input />
                    <Dropdown
                      button
                      basic
                      floating
                      onChange={this.handleSearchTypeChange}
                      options={search_options}
                      value={searchType}
                      disabled={
                        currentType === 'no_matches'
                          || currentType === 'ignored'
                          || currentType === 'variable_field_matches'
                          || currentType === 'function_kernel_matches'
                      }
                    />
                  </Input>
                  <div
                    className={cx('btn-close', {
                      active: searchKeyword !== '',
                    })}
                    onClick={this.clearSearch}
                    onKeyUp={this.clearSearch}
                    name="close"
                  >
                    <img src={clearBtn} alt="" />
                  </div>
                </div>
              </div>
              <div className="export-section">
                <div className="select-all-checkbox">
                  <Checkbox
                    label={isAllSelected ? translate('contents_header.button.unselect_all') : translate('contents_header.button.select_all')}
                    checked={isAllSelected}
                    onChange={this.handleCheckAllToggle}
                  />
                </div>
                <Dropdown
                  selection
                  options={format_options}
                  value={exportFormat}
                  onChange={this.handleExportFormat}
                />
                <Popup
                  trigger={(
                    <a
                      className={`export_button ${(selectedTabs.length === 0 || isFetching) ? 'disabled' : ''}`}
                      onClick={(selectedTabs.length === 0 || isFetching) ? undefined : this.exportReportToFile}
                      onKeyUp={(selectedTabs.length === 0 || isFetching) ? undefined : this.exportReportToFile}
                      role="button"
                      tabIndex={0}
                    >
                      {
                        isFetching ? (
                          <span>
                            <Loader active inline size="small" />
                          </span>
                        ) : (
                          <span>
                            <Icon className="download" />
                            {translate('modal.button.export_file')}
                          </span>
                        )
                      }
                    </a>
                  )}
                  position="bottom right"
                >
                  <div style={{ fontSize: '12px', color: '#4a4a4a', lineHeight: '1.5' }}>
                    {translate('modal.message.export_matched_detail_file')}
                  </div>
                </Popup>
              </div>
            </div>
            <Tab defaultActiveIndex={0} onTabChange={this.handleTabChange} panes={result} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(MatchedModal)));
